export default __webpack_public_path__ + "static/casestudy_6-cae619855164624c07560178e01ec3dd.png";